export default __webpack_public_path__ + "static/media/Wait Up.34b4e3b6.png";